/**
 * @generated SignedSource<<20eb1f3015bfa6ca779e1d531571bcff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Roadmaps_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Nav4RoadmapsWithRecent_query">;
  readonly " $fragmentType": "Nav4Roadmaps_query";
};
export type Nav4Roadmaps_query$key = {
  readonly " $data"?: Nav4Roadmaps_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Roadmaps_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentURL"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4Roadmaps_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "currentURL",
          "variableName": "currentURL"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Nav4RoadmapsWithRecent_query"
    }
  ],
  "type": "Query"
};

(node as any).hash = "47fec372203af44a34a1cc7d09c55e56";

export default node;
